module.exports = __webpack_public_path__ + "img/ade3d22.jpg";